import { useEffect } from "react";


// Used for Enquiry & Sales Order Product Service
export function useResetTableOnTabChange(
  tableKey: string,
  activeTab: string | undefined,
  resetState: () => void
) {
  useEffect(() => {
    if (!activeTab) return;

    const storageKey = `${tableKey}-last-tab`;
    const prevTab = sessionStorage.getItem(storageKey);

    // 🔥 Reset ONLY when tab actually changes
    if (prevTab && prevTab !== activeTab) {
      resetState();
    }

    sessionStorage.setItem(storageKey, activeTab);
  }, [activeTab, resetState, tableKey]);
}
